import { render } from "./PrizeResultModal.vue?vue&type=template&id=29d48c2b&scoped=true"
import script from "./PrizeResultModal.vue?vue&type=script&setup=true&lang=js"
export * from "./PrizeResultModal.vue?vue&type=script&setup=true&lang=js"

import "./PrizeResultModal.vue?vue&type=style&index=0&id=29d48c2b&scoped=true&lang=css"

import exportComponent from "/Users/luoke/Desktop/新开发代码_git/h5-jalalive/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-29d48c2b"],['__file',"src/views/me/PrizeResultModal.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "29d48c2b"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('29d48c2b', __exports__)) {
    console.log('reload')
    api.reload('29d48c2b', __exports__)
  }
  
  module.hot.accept("./PrizeResultModal.vue?vue&type=template&id=29d48c2b&scoped=true", () => {
    console.log('re-render')
    api.rerender('29d48c2b', render)
  })

}


export default __exports__